export default __webpack_public_path__ + "static/media/480_dummy2016-goldschmiede01-de.444d47b7.png";